import React, {useEffect, useState} from 'react'
import { Form } from 'react-bootstrap'
import { getPositions, uData, updateProfile } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {DeleteForever } from '@mui/icons-material'; 
import { useSelector } from 'react-redux';
import Cookie from 'react-cookies';
import statesData from './states.json'
const UserProfile = () => {
    const user = useSelector(state => state.user.payload);
	const navigate = useNavigate()
	const [data, setData ] = useState(user);
	const [password, setPassword] = useState('');
	const [image, setImage] = useState(user.image);
	const [imageStatus, setImageStatus] = useState(false);
	const [states, setStates] = useState(statesData);
	const [lgas, setLgas] = useState();
	const [positions, setPositions] = useState(null);
    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }
	const fetchPositions = async () => {
		const res = await getPositions();
		if(res.success){
			setPositions(res.data);
		}
	}
    const handleSubmit = async (e) => {
      e.preventDefault()
	//   window.start_load();
	  let formId = document.getElementById('newUser');
      const formData = new FormData(formId);
	//   formData.append('staffId', user.memberId);
	  	const process = async () => {
			if(image && typeof(image) !== 'string'){
				if(typeof(image[0]) === 'object'){
				formData.append('file', image[0]);
				formData.append('imageStatus', 1);
			}else{
			formData.append('imageStatus', 0);
			}
		} 
		const response = await updateProfile(formData);
		if(response.success){
			// Swal.fire('Success', response.message, 'success');///
			Swal.fire({
				title: 'Successful',
				icon:"success",
				text: response.message,
				closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
			})
			// uData(navigate, token);
			uData(navigate, Cookie.load('token'));
			setImage(user.image);
			setData(user);
		}else{
			// Swal.fire('Failed', response.message, 'error')
			Swal.fire({
				title: 'Failed',
				icon:"error",
				text: response.message,
				// showCloseButton: true,
				showConfirmButton: false,
				timer: 5000
				// closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
			})
		}
	  }
		process();
    }

	useEffect(() => {
		document.title = 'User Profile | Taste Place Investment'
		fetchPositions();
		setImage(user.image);
	}, [])
	
	useEffect(() => {
		setImage(user.img);
		setData(user);
		user.image && setImageStatus(true)
		user.image && setImage(user.image);
	}, [user])
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">User Profile </b></h4> 
      <div className="card">
		<div className="card-body">
			<form action="" id="newUser"
			onSubmit={handleSubmit}
			>
				<div className="row">
					<div className="col-md-6 border-right">
						<b className="text-muted">Personal Information</b>
						{
							 !imageStatus && 
							 <div className='d-flex justify-content-center align-items-center'>
                        <input type="file"  
                        onChange={(e) => {
                            // let media = [...newsImages.media,...e.target.files]
                          setImage(e.target.files)
						  setImageStatus(true)
                            // dispatch(addProduct({media}))
                        }}
                        style={{display:"none"}} placeholder="Type here" name='file' className="form-control" id="uploadImages"
                        />
                        <label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
                                display: "block",
                                width: "90%",
                                height:140,
                                borderStyle:'dashed',
                                borderColor:'GrayText',
                                borderWidth:0.5,
                                borderRadius:5,
                            }
                        }>
                            <span style={{fontSize:16}}> Click to Add  Profile Image</span>
                        </label>
                        </div>
						}
						{
							imageStatus && 
							<div className='products-container d-flex justify-content-start align-items-center m-2'>
                            
                                        <div className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
                                            cursor: "pointer",
                                            borderRadius:5,
                                            borderWidth:1,
                                            borderColor:"#e0e2e3",
                                }} >
                                        <img
                                            src={  typeof(image[0]) === 'object' ? URL.createObjectURL(image[0]) : image}
                                            alt={'passport'}
											width={150}
                                            height={100}
                                        />
                                        {/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
                                            setNewsImages(newsImages.filter((_,ind)=> ind != index))
                                        }}>
                                            <i className="material-icons md-delete_forever"></i>
                                        </div> */}
                                        {
											user.image  === '' &&
											<DeleteForever
											className='d-flex justify-content-center align-self-center justify-contents-center'
											color='error'
											onClick={() => {
												setImageStatus(false)
												setImage('')
											}
											}
											/>
										}
                                </div>
                            
                        </div>
						}
						<div className="form-group">
							<label for="" className="control-label">Name</label>
							<input
                            value={data.name}
							onChange={handleChange}
							type="text" name="name" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Email</label>
							<input 
                            value={data.email}
							onChange={handleChange}
							type="email" className="form-control form-control-sm" name="email" required  />
							<small id="#msg"></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Phone</label>
							<input 
                            value={data.phone}
							onChange={handleChange}
							type="text" name="phone" className="form-control form-control-sm"  required />
						</div>
						<div className="form-group">
							<label className="control-label">Date of Birth</label>
							<input
							value={data.dob}
							onChange={handleChange}
							type="date" className="form-control form-control-sm" name="dob" />
						</div>
						<div className="form-group">
							<label className="control-label">Highest Qualification </label>
							<Form.Select 
							onChange={handleChange}
							value={data.qualification}
							size='sm' name="qualification" id="qualification" className="form-control"
							required
							>
								<option value="" >Select Qualification ... </option>
								<option value="PHD" >PHD </option>
								<option value="MSC" >MSC</option>
								<option value="Degree" >BSC/BTECH/BENG/BED </option>
								<option value="HND" >HND</option>
								<option value="OND" >OND </option>
								<option value="NCE" >NCE</option>
								<option value="SSCE" >SSCE </option>
								<option value="JSCE" >JSCE</option>
								<option value="PSLC" >PSLC </option>
							</Form.Select>
						</div>
						<div className="form-group">
							<label className="control-label">Course of Study </label>
							<input 
							onChange={handleChange}
							value={data.course}
							type="text" className="form-control form-control-sm" name="course" 
							required
							/>
							
						</div>
					</div>
					<div className="col-md-6">
					<b className="text-muted">Other Details </b>
					<div className="form-group">
						<label className="control-label">Date of Employment</label>
						<input
						value={data.doe}
						onChange={handleChange}
						type="date" className="form-control form-control-sm" name="doe"/>
					</div>
					<div className="form-group">
						<label className="control-label">Origin</label>
						<div className='d-flex justify-content-between'>
							<div className='form-group'>
								<label className="control-label">State</label>
								<Form.Select name='state' 
								value={data.state}
								required
								onChange={(e)=>{
									setLgas(JSON.parse(e.target.value).lgas)
									setData({...data, state:JSON.parse(e.target.value).state})
								}}>
									<option value={data.state}> {data.state} </option>
									{
										states.map((state, i) => 
										{

										return(
											<option value={JSON.stringify(state)} key={i}
											> {state.state }</option>
										)})
									}
								</Form.Select>
							</div>
							<div className='form-group'>
								<label className="control-label">LGA</label>
								<Form.Select name='lga' 
								required
								value={data.lga}
								onChange={handleChange}>
									<option value={data.lga} > {data.lga} </option>
									{
										lgas && lgas.map((lga, i) => (
											<option value={lga} key={i}>{lga}</option>
										))
									}
								</Form.Select>
							</div>
						</div>
							
					</div>
					<div className="form-group">
							<label className="control-label">Address </label>
							<input 
                            value={data.address}
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="address" 
							required
							/>
							
						</div>
					<div className="form-group">
						<label className="control-label">Permanent Home Address </label>
						<input 
						value={data.permanent_address}
						onChange={handleChange}
						type="text" className="form-control form-control-sm" name="permanent_address" 
						required
						/>
							
					</div>
					<div className="form-group">
						<label for="" className="control-label">Gender</label>
						<Form.Select 
						value={data.gender}
						onChange={handleChange}
						required
						size='sm' name="gender" id="gender" className="form-control">
							<option value="" >Select Gender ... </option>
							<option value="male" >Male </option>
							<option value="female" >Female</option>
						</Form.Select>
						<small><i></i></small>
					</div>
						<div className="form-group">
							<label className="control-label">Position </label>
							<Form.Select disabled={user.access_type > 1 ? false : true}
							value={data.position}
							required
							onChange={(e) => {
								let value = JSON.parse(e.target.value);
								setData({...data, position: value.title, 
									access_type: value.access_type, 
									category: value.category})
							}}
							size='sm' name="position" id="position" className="form-control">
								<option value={data.position} >{data.position} </option>
								{
									positions && 
									positions.map((position, i) => (
										<option value={JSON.stringify(position)}  key={i}> {position.title}</option>
									))
								}
							</Form.Select>
						</div>
						<div className="form-group">
							<label className="control-label">Staff ID</label>
							<input 
                            value={data.staffId}
                            disabled
							onChange={handleChange}
							type="text" className="form-control form-control-sm" name="staffId"/>
							
						</div>
						{/* <div className="form-group">
							<label for="" className="control-label">Account Status</label>
							<Form.Select 
							onChange={handleChange}
							size='sm' name="status" id="type" className="form-control">
								<option value="" >Select Status ... </option>
								<option value="1" >Active </option>
								<option value="0" >Disabled</option>
							</Form.Select>
							<small><i></i></small>
						</div> */}
					</div>
				</div>
				<hr />
				<div className="col-lg-12 text-right justify-content-center d-flex">
					 <button className="btn btn-danger btn-lg" type="button" 
					 onClick={()=> {
						navigate('/dashboard');
					 }}
					 style={{ width: '120px' }}
					 >Cancel</button>
					 <button
					 
					 className="btn btn-color btn-lg ms-2"
					  style={{ width: '120px' }}
					 >Update</button> 
				</div>
			</form>
		</div>
	</div>
    </div>
  )
}

export default UserProfile